import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function AuthHashHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hash = window.location.hash;
    
    if (hash && (hash.includes('access_token') || hash.includes('refresh_token') || hash.includes('type=recovery') || hash.includes('type=invite'))) {
      if (location.pathname !== '/auth/callback' && location.pathname !== '/auth/set-password') {
        navigate('/auth/callback', { replace: true });
      }
    }
  }, [location, navigate]);

  return null;
}
